<template>
  <pt-doctor-manage class="pt-doctor-manage__withData" @deleteDoctor="deleteDoctor" ref="table" @exportDoctorQrcode="exportDoctorQrcode" :exportLoading="exportLoading"></pt-doctor-manage>
</template>

<script>
import PtDoctorManage from './index'
export default {
  name: 'pt-doctor-manage__withData',
  components: {
    'pt-doctor-manage': PtDoctorManage
  },
  data () {
    return {
      exportLoading: false
    }
  },
  methods: {
    exportDoctorQrcode (val) {
      let AjaxUrl = val.url
      let data = {
        ...val.data
      }
      this.exportLoading = true
      this.$store.dispatch(AjaxUrl, data).then(res => {
        this.exportLoading = false
        // dataExport(res)
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出数据失败')
      })
    },
    deleteDoctor (id) {
      this.$store.dispatch('deleteDoctor', id).then(res => {
        this.$message.success('删除医生成功')
        this.$refs.table.getTableData()
      }).catch(err => {
        this.$message.error(err || '删除医生失败')
      })
    }
  }
}
</script>
